export default __webpack_public_path__ + "static/booking-scam-dcfbe7814f3f06cdf8ef3d7ffc1b055d.webp";